export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"}],"link":[{"rel":"preconnect","href":"https://a.storyblok.com"},{"rel":"dns-prefetch","href":"https://a.storyblok.com"},{"rel":"preconnect","href":"https://cdn-ukwest.onetrust.com"},{"rel":"preload","href":"https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js","as":"script"},{"rel":"preload","href":"https://cdn-ukwest.onetrust.com/scripttemplates/202501.1.0/otBannerSdk.js","as":"script"},{"rel":"preconnect","href":"https://www.googletagmanager.com"},{"rel":"preload","href":"https://www.googletagmanager.com/gtm.js?id=GTM-KKXLTQKR","as":"script"}],"style":[],"script":[{"innerHTML":"\n                        window.addEventListener('load', function(){\n                            setTimeout(function(){\n                                var link = document.createElement('link');\n                                link.rel = 'stylesheet';\n                                link.href = 'https://use.typekit.net/jva3fmf.css';\n                                document.head.appendChild(link);\n                            }, 5000);\n                        });\n                    ","type":"text/javascript"},{"innerHTML":"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                                })(window,document,'script','dataLayer','GTM-KKXLTQKR');","type":"text/javascript"},{"innerHTML":"function getCookie(cname) {\n    var name = cname + '=';\n    var decodedCookie = decodeURIComponent(document.cookie);\n    var ca = decodedCookie.split(';');\n    for (var i = 0; i < ca.length; i++) {\n        var c = ca[i];\n        while (c.charAt(0) == ' ') {\n            c = c.substring(1);\n        }\n        if (c.indexOf(name) == 0) {\n            return c.substring(name.length, c.length);\n        }\n    }\n    return '';\n}\n\nfunction loadOneTrust() {\n    var oneTrustScript = document.createElement('script');\n    oneTrustScript.setAttribute('src', 'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js');\n    oneTrustScript.setAttribute('async', 'true');\n    oneTrustScript.setAttribute('data-document-language', 'true');\n    oneTrustScript.setAttribute('data-domain-script', '7998422b-d6c3-4066-9168-c124b099521e');\n    document.head.appendChild(oneTrustScript);\n}\n\nif (getCookie('OptanonAlertBoxClosed')) {\n    // Load OneTrust on load if we already have consent\n    loadOneTrust();\n} else {\n    // Load OneTrust on interaction if we don't have consent\n    [\n        'mousemove',\n        'scroll',\n        'keydown',\n        'click',\n        'wheel',\n        'focus',\n        'touchstart',\n        'touchmove',\n        'touchend',\n        'touchcancel',\n    ].forEach(function (event) {\n        window.addEventListener(\n            event,\n            function () {\n                loadOneTrust();\n            },\n            { once: true, passive: true }\n        );\n    });\n}","type":"text/javascript"},{"innerHTML":"window.uetq = window.uetq || [];\n                    window.uetq.push('consent', 'default', {\n                        'ad_storage': 'denied'\n                    });","type":"text/javascript"},{"innerHTML":"gtag('consent', 'default', {\n                        'ad_storage': 'denied',\n                        'ad_user_data': 'denied',\n                        'ad_personalization': 'denied',\n                        'analytics_storage': 'denied'\n                    });","type":"text/javascript"}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"prefetch":false,"externalRelAttribute":"","componentName":"NuxtLink","prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true